import actions from './actions';

const {
  LIST_LOYALTY_POINTS_LEVELS_BEGIN,
  LIST_LOYALTY_POINTS_LEVELS_SUCCESS,
  LIST_LOYALTY_POINTS_LEVELS_ERR,
  GET_LOYALTY_POINTS_LEVEL_DETAILS_BEGIN,
  GET_LOYALTY_POINTS_LEVEL_DETAILS_SUCCESS,
  GET_LOYALTY_POINTS_LEVEL_DETAILS_ERR,
  UPDATE_LOYALTY_POINTS_LEVEL_BEGIN,
  UPDATE_LOYALTY_POINTS_LEVEL_SUCCESS,
  UPDATE_LOYALTY_POINTS_LEVEL_ERR,
  ENABLE_LOYALTY_POINTS_LEVEL_BEGIN,
  ENABLE_LOYALTY_POINTS_LEVEL_SUCCESS,
  ENABLE_LOYALTY_POINTS_LEVEL_ERR,
  LIST_LOYALTY_POINTS_TRANSACTIONS_BEGIN,
  LIST_LOYALTY_POINTS_TRANSACTIONS_SUCCESS,
  LIST_LOYALTY_POINTS_TRANSACTIONS_ERR,
} = actions;

const initState = {
  loyaltyPointsLevels: [],
  loadingListLoyaltyPointsLevels: false,
  errorListLoyaltyPointsLevels: null,

  loyaltyPointsLevelDetails: null,
  loadingLoyaltyPointsLevelDetails: false,
  errorLoyaltyPointsLevelDetails: null,

  loadingUpdateLoyaltyPointsLevel: false,
  errorUpdateLoyaltyPointsLevel: null,

  loyaltyPointsTransactions: [],
  loadingListLoyaltyPointsTransactions: false,
  errorListLoyaltyPointsTransactions: null,
  totalLoyaltyPointsTransactions: 0,

  loadingEnableLoyaltyPointsLevel: false,
  errorEnableLoyaltyPointsLevel: null,
};

const loyaltyPointsLevelsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case LIST_LOYALTY_POINTS_LEVELS_BEGIN:
      return {
        ...state,
        loyaltyPointsLevels: [],
        loadingListLoyaltyPointsLevels: true,
        errorListLoyaltyPointsLevels: null,
      };
    case LIST_LOYALTY_POINTS_LEVELS_SUCCESS:
      return {
        ...state,
        loyaltyPointsLevels: [...data],
        loadingListLoyaltyPointsLevels: false,
        errorListLoyaltyPointsLevels: null,
      };
    case LIST_LOYALTY_POINTS_LEVELS_ERR:
      return {
        ...state,
        errorListLoyaltyPointsLevels: err,
        loadingListLoyaltyPointsLevels: false,
      };
    case GET_LOYALTY_POINTS_LEVEL_DETAILS_BEGIN:
      return {
        ...state,
        loyaltyPointsLevelDetails: null,
        loadingLoyaltyPointsLevelDetails: true,
        errorLoyaltyPointsLevelDetails: null,
      };

    case GET_LOYALTY_POINTS_LEVEL_DETAILS_SUCCESS:
      return {
        ...state,
        loyaltyPointsLevelDetails: data,
        loadingLoyaltyPointsLevelDetails: false,
        errorLoyaltyPointsLevelDetails: null,
      };

    case GET_LOYALTY_POINTS_LEVEL_DETAILS_ERR:
      return {
        ...state,
        loyaltyPointsLevelDetails: null,
        loadingLoyaltyPointsLevelDetails: false,
        errorLoyaltyPointsLevelDetails: err,
      };

    case UPDATE_LOYALTY_POINTS_LEVEL_BEGIN:
      return {
        ...state,
        loadingUpdateLoyaltyPointsLevel: true,
        errorUpdateLoyaltyPointsLevel: null,
      };
    case UPDATE_LOYALTY_POINTS_LEVEL_SUCCESS:
      console.log('Updated Loyalty Points Levels  ::: ', data);

      // eslint-disable-next-line no-case-declarations
      const updatedList = state.loyaltyPointsLevels.map((item) =>
        item.LOYALTY_POINTS_LEVEL_id === data.LOYALTY_POINTS_LEVEL_id ? data : item,
      );
      return {
        ...state,
        loyaltyPointsLevels: [...updatedList],
        loadingUpdateLoyaltyPointsLevel: false,
        errorUpdateLoyaltyPointsLevel: null,
      };
    case UPDATE_LOYALTY_POINTS_LEVEL_ERR:
      return {
        ...state,
        errorUpdateLoyaltyPointsLevel: err,
        loadingUpdateLoyaltyPointsLevel: false,
      };

    case ENABLE_LOYALTY_POINTS_LEVEL_BEGIN:
      return {
        ...state,
        loadingEnableLoyaltyPointsLevel: true,
        errorEnableLoyaltyPointsLevel: null,
      };
    case ENABLE_LOYALTY_POINTS_LEVEL_SUCCESS:
      return {
        ...state,
        loadingEnableLoyaltyPointsLevel: false,
        errorEnableLoyaltyPointsLevel: null,
      };
    case ENABLE_LOYALTY_POINTS_LEVEL_ERR:
      return {
        ...state,
        errorEnableLoyaltyPointsLevel: err,
        loadingEnableLoyaltyPointsLevel: false,
      };

    case LIST_LOYALTY_POINTS_TRANSACTIONS_BEGIN:
      return {
        ...state,
        loadingListLoyaltyPointsTransactions: true,
        errorListLoyaltyPointsTransactions: null,
      };
    case LIST_LOYALTY_POINTS_TRANSACTIONS_SUCCESS:
      console.log('Loyalty Points Transactions list::: ', data);
      return {
        ...state,
        loyaltyPointsTransactions: [...data.results],
        loadingListLoyaltyPointsTransactions: false,
        errorListLoyaltyPointsTransactions: null,
        totalLoyaltyPointsTransactions: data.total_count,
      };
    case LIST_LOYALTY_POINTS_TRANSACTIONS_ERR:
      return {
        ...state,
        errorListLoyaltyPointsTransactions: err,
        loadingListLoyaltyPointsTransactions: false,
        totalLoyaltyPointsTransactions: 0,
      };

    default:
      return state;
  }
};

export { loyaltyPointsLevelsReducer };
